// MEGA MENU ITEMS
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-item');
  console.log('Menu Items:', menuItems); // Check if this logs the correct menu items

  menuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      console.log('Main menu item hovered:', this); // Logs when the main menu is hovered
      const megaMenu = this.querySelector('.mega-menu');
      if (megaMenu) {
        console.log('Mega menu found for:', this); // Logs if the mega menu is found

        // Show the mega menu
        document.querySelectorAll('.mega-menu.active').forEach(menu => menu.classList.remove('active'));
        megaMenu.classList.add('active');
      }
    });

    // Hide mega menu on mouse leave
    // item.addEventListener('mouseleave', function() {
    //   const megaMenu = this.querySelector('.mega-menu');
    //   if (megaMenu) {
    //     megaMenu.classList.remove('active'); // Hide the mega menu on mouse out
    //   }
    // });

    // Get all child items within the current menu item
    const childItems = item.querySelectorAll('.child-item');

    // Loop through each child item
    childItems.forEach(child => {
      child.addEventListener('mouseenter', function(event) {
        event.stopPropagation(); // Prevent the event from bubbling up to parent elements
        console.log('Child item hovered:', this); // Logs when a child item is hovered

        const grandchildMenu = this.querySelector('.grandchild-content');
        const arrowIcon = this.querySelector('.arrow-icon');
        if (grandchildMenu) {
          // Show the grandchild menu
          const allGrandchildMenus = item.querySelectorAll('.grandchild-content.active');
          allGrandchildMenus.forEach(menu => menu.classList.remove('active'));

          const allArrowIcons = item.querySelectorAll('.arrow-icon.active');
          allArrowIcons.forEach(menu => menu.classList.remove('active'));

          grandchildMenu.classList.add('active');
          arrowIcon.classList.add('active'); // Rotate arrow icon
        }
      });

      child.addEventListener('mouseleave', function(event) {
        event.stopPropagation(); // Prevent the event from bubbling up to parent elements
        const grandchildMenu = this.querySelector('.grandchild-content');
        const arrowIcon = this.querySelector('.arrow-icon');
        if (grandchildMenu) {
          grandchildMenu.classList.remove('active');
          arrowIcon.classList.remove('active'); // Reset arrow icon
        }
      });
    });

    // Hide all mega menus when the mouse moves anywhere outside the menu items and the main content area
  document.querySelector('#MainContent').addEventListener('mousemove', function(event) {
    const menuContainer = document.querySelector('.menu-items');
    const activeMegaMenu = document.querySelector('.mega-menu.active');

    // Check if the mouse is outside both the menu items and the active mega menu
    if (menuContainer && activeMegaMenu && !menuContainer.contains(event.target) && !activeMegaMenu.contains(event.target)) {
      document.querySelectorAll('.mega-menu.active').forEach(menu => menu.classList.remove('active'));
    }
  });
    
  });
});

// Adjust column count based on the number of list items for mega menu 
document.addEventListener('DOMContentLoaded', function() {
  const grandchildLinks = document.querySelectorAll('.grandchild-links');

  grandchildLinks.forEach(function(links) {
    const listItems = links.querySelectorAll('.grandchild-li');

    // Check if there are at least 6 list items
    if (listItems.length >= 6) {
      links.style.columnCount = 2;
    } else {
      links.style.columnCount = 1;
    }
  });
});

// Close and Open Mobile Menu Hambuger and close button
document.addEventListener('DOMContentLoaded', () => {
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const closeButton = document.querySelector('.close-button');
  const mobileMenu = document.getElementById('mobileMenu');

  // Open the mobile menu
  hamburgerBtn.addEventListener('click', () => {
    mobileMenu.classList.remove('closed');
    mobileMenu.classList.add('open');

     openFirstMegaMenu();
  });

  // Close the mobile menu
  closeButton.addEventListener('click', () => {
    mobileMenu.classList.remove('open');
    mobileMenu.classList.add('closed');

        closeAllChildLinks();
  });
});

function openFirstMegaMenu() {
  const menuItemsMobile = document.querySelectorAll('.mobile-menu-item');

  if (menuItemsMobile.length > 0) {
      console.log("this is: ", menuItemsMobile);
    const firstMenuItem = menuItemsMobile[0];
    console.log(firstMenuItem);
    const firstMegaMenu = firstMenuItem.querySelector('.mobile-mega-menu');
    console.log(firstMegaMenu);
    if (firstMegaMenu) {
      firstMegaMenu.classList.add('open'); // Set the first mega menu as active
    }
  }
}

// MOBILE MEGA MENU ITEMS
document.addEventListener('DOMContentLoaded', () => {
  const menuItemsMobile = document.querySelectorAll('.mobile-menu-item');
  const mobileMenu = document.querySelector('.mobile-menu-items');

  // Function to toggle display style using 'active' class
  function toggleClass(element, className) {
    element.classList.toggle(className);
  }

  // Function to close all child links
  function closeAllChildLinks() {
    document.querySelectorAll('.mobile-mega-menu').forEach(menu => {
      menu.classList.remove('active');
    });
  }

  // Function to close all grandchild links
  function closeAllGrandchildLinks() {
    document.querySelectorAll('.mobile-grandchild-links').forEach(menu => {
      menu.classList.remove('active');
    });
  }

  // Toggle child links when a menu item is clicked
  menuItemsMobile.forEach(item => {
    item.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevents the event from bubbling up

      // Close all other mega menus
      closeAllChildLinks();

      // Toggle the child menu for the clicked main menu item
      const megaMenuMobile = this.querySelector('.mobile-mega-menu');
      if (megaMenuMobile) {
        toggleClass(megaMenuMobile, 'active');
      }
    });

    // Handle click on child items to toggle grandchild menu
    const childItemsMobile = item.querySelectorAll('.mobile-child-item');
  childItemsMobile.forEach(child => {
    child.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevents the event from bubbling up

        // Close other grandchild menus
        closeAllGrandchildLinks();

        // Get the ID of the clicked child item
        const childId = this.querySelector('a').dataset.childId;

        // Hide arrow icons of other child items
        const allArrowIcons = document.querySelectorAll('.arrow-icon');
        allArrowIcons.forEach(arrow => {
            arrow.classList.remove('active'); // Hide all arrows
        });

        // Get the corresponding grandchild links container
        const grandchildMenuMobile = document.querySelector(`.mobile-grandchild-links[data-child-id="${childId}"]`);

        if (grandchildMenuMobile) {
            // Toggle the grandchild links display
            toggleClass(grandchildMenuMobile, 'active');
            const arrowIcon = this.querySelector('.arrow-icon');
            if (arrowIcon) {
                arrowIcon.classList.toggle('active'); // Show the arrow for the active item
            }
        }
    });
});

  });

  // Close all menus when clicking outside
  document.addEventListener('click', function(e) {
    if (!mobileMenu.contains(e.target) && !e.target.closest('.mobile-menu-item')) {
      closeAllChildLinks();
      closeAllGrandchildLinks();
    }
  });

  // Prevent closing menus when clicking inside the menu
  mobileMenu.addEventListener('click', function(e) {
    e.stopPropagation();
  });
  
});

// ARROW ICON
const childItemsArrow = document.querySelectorAll(`.mobile-grandchild-links[data-child-id="${childId}"]`);

childItemsArrow.forEach(child => {
  child.addEventListener('click', event => {
    console.log('Child item clicked!');
    const arrowIcon = child.querySelector('.arrow-icon');
    
    if (arrowIcon) {
      arrowIcon.classList.toggle('active'); // Add/remove the 'active' class
    }
  });
});

